/* eslint-disable no-param-reassign */

import { isObject } from "lodash-es";
import { isString } from "./langUtils";

export function couldBeAnEndressHauserSerialNumber(serialNumber: $TSFixMe) {
  return (
    serialNumber &&
    isString(serialNumber) &&
    // @ts-expect-error TS(2345) FIXME: Argument of type 'string | String' is not ass... Remove this comment to see the full error message
    /^[0-9a-zA-Z\-_]{4,18}$/.test(serialNumber)
  );
}

// can be used to clean errors at the end of validateForm before returning them to the form
// errors object must be empty, null attributes need to be deleted.
export function removeNullAttributes(obj: $TSFixMe) {
  if (!isObject(obj)) {
    return obj;
  }
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  Object.keys(obj).forEach((key) => obj[key] == null && delete obj[key]);
  return obj;
}

export function luhnCheck(num: $TSFixMe) {
  const arr = `${num}`
    .split("")
    .reverse()
    .map((x) => parseInt(x, 10));
  const lastDigit = arr.splice(0, 1)[0];
  let sum = arr.reduce(
    (acc, val, i) => (i % 2 !== 0 ? acc + val : acc + ((val * 2) % 9) || 9),
    0,
  );
  sum += lastDigit;
  return sum % 10 === 0;
}
